import { c as _c } from "react/compiler-runtime";
import { NeutralButton, PrimaryButton } from '@systemeio/ui';
import ContactsListingLayout from 'modules/contacts/components/contact-listing-layout';
import ContactsMenu from 'modules/contacts/components/contacts-menu';
import { ContactsLoco } from 'modules/contacts/constants/contacts-loco';
import { getContactsBinPageNextjsUrl } from 'modules/contacts/contacts-bin/utils/get-contacts-bin-page-nextjs-url';
import { getContactsImportPageNextjsUrl } from 'modules/contacts/contacts-import/utils/get-contacts-import-page-nextjs-url';
import { useApplyFilterWithConditions } from 'modules/contacts/hooks/use-apply-filter-with-conditions';
import { useContactFilterActions } from 'modules/contacts/hooks/use-contact-filter-actions';
import { useContactFilterPagination } from 'modules/contacts/hooks/use-contact-filter-pagination';
import { useContactSavedFilters } from 'modules/contacts/hooks/use-contact-saved-filters';
import { useContacts } from 'modules/contacts/hooks/use-contacts';
import { useFilterWithConditions } from 'modules/contacts/hooks/use-filter-with-conditions';
import { useRenderContactFilters } from 'modules/contacts/hooks/use-render-contact-filters';
import { NextPage } from 'next';
import React, { useState } from 'react';
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch';
import { Table } from 'shared/components/table/table';
import { useListingSelect } from 'shared/hooks/use-listing-select';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import useWindowSize from 'shared/hooks/use-window-size';
import { getBaseServerSideProps } from 'shared/utils/get-base-server-side-props';
import { getContactColumns } from '../../modules/contacts/configs/contact-tabel-colums';
import { AddIcon, ContactIcon, TrashClockIcon } from '@systemeio/ui/icons';
import { OrderEnum } from 'shared/types/pagination-interface';
const Contacts: NextPage = () => {
  const $ = _c(122);
  const {
    user,
    isRestrictedUser
  } = useUser();
  const {
    t
  } = useLocoTranslation();
  const {
    savedFields,
    mutateSavedFields
  } = useContactSavedFilters();
  const {
    setConditions,
    conditions,
    filter,
    setFilter,
    filtersReady,
    clearFilter,
    filterFields
  } = useFilterWithConditions();
  const [needToCloseFilters, setNeedToCloseFilters] = useState(false);
  let t0;
  if ($[0] !== clearFilter) {
    t0 = () => {
      clearFilter();
      setNeedToCloseFilters(true);
    };
    $[0] = clearFilter;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const onResetFilters = t0;
  let t1;
  if ($[2] !== filter || $[3] !== filterFields || $[4] !== filtersReady || $[5] !== needToCloseFilters || $[6] !== setFilter) {
    t1 = {
      filter,
      filterFields,
      filtersReady,
      setFilter,
      needToCloseFilters,
      setNeedToCloseFilters
    };
    $[2] = filter;
    $[3] = filterFields;
    $[4] = filtersReady;
    $[5] = needToCloseFilters;
    $[6] = setFilter;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  const renderFilters = useRenderContactFilters(t1);
  let t2;
  if ($[8] !== clearFilter || $[9] !== filter || $[10] !== filterFields || $[11] !== mutateSavedFields || $[12] !== setFilter) {
    t2 = {
      clearFilter,
      filterFields,
      mutateSavedFields,
      filter,
      setFilter
    };
    $[8] = clearFilter;
    $[9] = filter;
    $[10] = filterFields;
    $[11] = mutateSavedFields;
    $[12] = setFilter;
    $[13] = t2;
  } else {
    t2 = $[13];
  }
  const {
    onSaveNewFilter,
    onDeleteSavedFilter,
    applySavedFilters
  } = useContactFilterActions(t2);
  let t3;
  if ($[14] !== conditions || $[15] !== setConditions) {
    t3 = {
      conditions,
      setConditions
    };
    $[14] = conditions;
    $[15] = setConditions;
    $[16] = t3;
  } else {
    t3 = $[16];
  }
  const {
    setPagination,
    pagination,
    setLimit,
    limit
  } = useContactFilterPagination(t3);
  let t4;
  if ($[17] !== conditions || $[18] !== limit || $[19] !== pagination) {
    t4 = {
      limit,
      pagination,
      conditions
    };
    $[17] = conditions;
    $[18] = limit;
    $[19] = pagination;
    $[20] = t4;
  } else {
    t4 = $[20];
  }
  const {
    contacts,
    counter,
    abortContacts,
    mutate
  } = useContacts(t4);
  const t5 = counter?.count;
  let t6;
  if ($[21] !== conditions || $[22] !== contacts || $[23] !== t5) {
    t6 = {
      listing: contacts,
      count: t5,
      filter: conditions
    };
    $[21] = conditions;
    $[22] = contacts;
    $[23] = t5;
    $[24] = t6;
  } else {
    t6 = $[24];
  }
  const {
    renderSelectButton,
    getListingSelect,
    renderSelectAllButton,
    isMenuShown
  } = useListingSelect(t6);
  let t7;
  if ($[25] !== setPagination) {
    t7 = () => setPagination({
      startFromId: undefined,
      order: OrderEnum.next
    });
    $[25] = setPagination;
    $[26] = t7;
  } else {
    t7 = $[26];
  }
  let t8;
  if ($[27] !== abortContacts || $[28] !== conditions || $[29] !== filter || $[30] !== filterFields || $[31] !== filtersReady || $[32] !== setConditions || $[33] !== setLimit || $[34] !== t7) {
    t8 = {
      abort: abortContacts,
      filterFields,
      filtersReady,
      setLimit,
      setConditions,
      conditions,
      filter,
      onFilterChange: t7
    };
    $[27] = abortContacts;
    $[28] = conditions;
    $[29] = filter;
    $[30] = filterFields;
    $[31] = filtersReady;
    $[32] = setConditions;
    $[33] = setLimit;
    $[34] = t7;
    $[35] = t8;
  } else {
    t8 = $[35];
  }
  useApplyFilterWithConditions(t8);
  const {
    width
  } = useWindowSize();
  let t9;
  if ($[36] !== t) {
    t9 = t("dashboard.contacts.title_plural");
    $[36] = t;
    $[37] = t9;
  } else {
    t9 = $[37];
  }
  let t10;
  if ($[38] !== limit || $[39] !== setLimit) {
    t10 = {
      limit,
      setLimit
    };
    $[38] = limit;
    $[39] = setLimit;
    $[40] = t10;
  } else {
    t10 = $[40];
  }
  let t11;
  if ($[41] !== pagination || $[42] !== setPagination) {
    t11 = {
      pagination,
      setPagination
    };
    $[41] = pagination;
    $[42] = setPagination;
    $[43] = t11;
  } else {
    t11 = $[43];
  }
  const t12 = savedFields?.items;
  let t13;
  if ($[44] !== filter || $[45] !== filterFields || $[46] !== setFilter || $[47] !== t12) {
    t13 = {
      setFilter,
      filter,
      filterFields,
      savedFilters: t12
    };
    $[44] = filter;
    $[45] = filterFields;
    $[46] = setFilter;
    $[47] = t12;
    $[48] = t13;
  } else {
    t13 = $[48];
  }
  let t14;
  if ($[49] !== applySavedFilters || $[50] !== onDeleteSavedFilter || $[51] !== onResetFilters || $[52] !== onSaveNewFilter || $[53] !== renderFilters || $[54] !== t10 || $[55] !== t11 || $[56] !== t13) {
    t14 = {
      limiter: t10,
      paginator: t11,
      applySavedFilters,
      onDeleteSavedFilter,
      onSaveNewFilter,
      onResetFilters,
      filterer: t13,
      filterable: renderFilters
    };
    $[49] = applySavedFilters;
    $[50] = onDeleteSavedFilter;
    $[51] = onResetFilters;
    $[52] = onSaveNewFilter;
    $[53] = renderFilters;
    $[54] = t10;
    $[55] = t11;
    $[56] = t13;
    $[57] = t14;
  } else {
    t14 = $[57];
  }
  const t15 = !!isRestrictedUser;
  let t16;
  if ($[58] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <AddIcon />;
    $[58] = t16;
  } else {
    t16 = $[58];
  }
  let t17;
  if ($[59] !== t) {
    t17 = t("dashboard.contacts.create_contact");
    $[59] = t;
    $[60] = t17;
  } else {
    t17 = $[60];
  }
  let t18;
  if ($[61] !== t17) {
    t18 = <span className="hidden lg:flex">{t17}</span>;
    $[61] = t17;
    $[62] = t18;
  } else {
    t18 = $[62];
  }
  let t19;
  if ($[63] !== t15 || $[64] !== t18) {
    t19 = <PrimaryButton as={LinkWithoutPrefetch} href="/contacts/create" aria-disabled={t15}>{t16}{t18}</PrimaryButton>;
    $[63] = t15;
    $[64] = t18;
    $[65] = t19;
  } else {
    t19 = $[65];
  }
  let t20;
  let t21;
  if ($[66] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = getContactsImportPageNextjsUrl();
    t21 = <ContactIcon />;
    $[66] = t20;
    $[67] = t21;
  } else {
    t20 = $[66];
    t21 = $[67];
  }
  let t22;
  if ($[68] !== t) {
    t22 = t("dashboard.contacts.import_contacts");
    $[68] = t;
    $[69] = t22;
  } else {
    t22 = $[69];
  }
  let t23;
  if ($[70] !== t22) {
    t23 = <NeutralButton as={LinkWithoutPrefetch} className="[&_svg]:hover:fill-brand-primary [&_svg]:main-transition-colors" href={t20}>{t21}<span className="hidden lg:flex">{t22}</span></NeutralButton>;
    $[70] = t22;
    $[71] = t23;
  } else {
    t23 = $[71];
  }
  let t24;
  if ($[72] !== t19 || $[73] !== t23) {
    t24 = <div className="flex gap-3">{t19}{t23}</div>;
    $[72] = t19;
    $[73] = t23;
    $[74] = t24;
  } else {
    t24 = $[74];
  }
  let t25;
  if ($[75] !== contacts || $[76] !== renderSelectAllButton || $[77] !== t) {
    t25 = contacts && contacts.items.length !== 0 && <div className="bg-brand-primary-subtle flex items-center gap-3 rounded-t-lg px-6 py-4 lg:hidden">{renderSelectAllButton()}<span>{t("global.select_all")}</span></div>;
    $[75] = contacts;
    $[76] = renderSelectAllButton;
    $[77] = t;
    $[78] = t25;
  } else {
    t25 = $[78];
  }
  const t26 = width < 1024 ? !!contacts : false;
  let t27;
  if ($[79] !== contacts || $[80] !== renderSelectAllButton || $[81] !== renderSelectButton || $[82] !== t || $[83] !== user || $[84] !== width) {
    t27 = getContactColumns({
      renderSelectButton,
      renderSelectAllButton,
      contacts,
      user,
      t,
      width
    });
    $[79] = contacts;
    $[80] = renderSelectAllButton;
    $[81] = renderSelectButton;
    $[82] = t;
    $[83] = user;
    $[84] = width;
    $[85] = t27;
  } else {
    t27 = $[85];
  }
  let t28;
  if ($[86] !== limit || $[87] !== setLimit) {
    t28 = {
      limit,
      setLimit
    };
    $[86] = limit;
    $[87] = setLimit;
    $[88] = t28;
  } else {
    t28 = $[88];
  }
  let t29;
  if ($[89] !== pagination || $[90] !== setPagination) {
    t29 = {
      pagination,
      setPagination
    };
    $[89] = pagination;
    $[90] = setPagination;
    $[91] = t29;
  } else {
    t29 = $[91];
  }
  let t30;
  let t31;
  if ($[92] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = getContactsBinPageNextjsUrl();
    t31 = <TrashClockIcon />;
    $[92] = t30;
    $[93] = t31;
  } else {
    t30 = $[92];
    t31 = $[93];
  }
  let t32;
  if ($[94] !== t) {
    t32 = t("dashboard.contacts.recently_deleted");
    $[94] = t;
    $[95] = t32;
  } else {
    t32 = $[95];
  }
  let t33;
  if ($[96] !== t32) {
    t33 = <NeutralButton as={LinkWithoutPrefetch} className="[&_svg]:hover:fill-brand-primary [&_svg]:main-transition-colors" href={t30}>{t31}<span className="hidden lg:flex">{t32}</span></NeutralButton>;
    $[96] = t32;
    $[97] = t33;
  } else {
    t33 = $[97];
  }
  let t34;
  if ($[98] !== contacts || $[99] !== t26 || $[100] !== t27 || $[101] !== t28 || $[102] !== t29 || $[103] !== t33) {
    t34 = <Table firstLineRect={t26} data={contacts} columns={t27} limiter={t28} paginator={t29} footerAdditionalElement={t33} />;
    $[98] = contacts;
    $[99] = t26;
    $[100] = t27;
    $[101] = t28;
    $[102] = t29;
    $[103] = t33;
    $[104] = t34;
  } else {
    t34 = $[104];
  }
  const t35 = filterFields?.items;
  let t36;
  if ($[105] !== conditions || $[106] !== getListingSelect || $[107] !== mutate || $[108] !== t35) {
    t36 = <ContactsMenu mutateContacts={mutate} conditions={conditions} fields={t35} getListingSelect={getListingSelect} />;
    $[105] = conditions;
    $[106] = getListingSelect;
    $[107] = mutate;
    $[108] = t35;
    $[109] = t36;
  } else {
    t36 = $[109];
  }
  let t37;
  if ($[110] !== t25 || $[111] !== t34 || $[112] !== t36) {
    t37 = <div className="w-full">{t25}{t34}{t36}</div>;
    $[110] = t25;
    $[111] = t34;
    $[112] = t36;
    $[113] = t37;
  } else {
    t37 = $[113];
  }
  let t38;
  if ($[114] !== contacts || $[115] !== counter || $[116] !== isMenuShown || $[117] !== t14 || $[118] !== t24 || $[119] !== t37 || $[120] !== t9) {
    t38 = <ContactsListingLayout counter={counter} data={contacts} title={t9} isMenuShown={isMenuShown} filterData={t14} customHeaderElement={t24}>{t37}</ContactsListingLayout>;
    $[114] = contacts;
    $[115] = counter;
    $[116] = isMenuShown;
    $[117] = t14;
    $[118] = t24;
    $[119] = t37;
    $[120] = t9;
    $[121] = t38;
  } else {
    t38 = $[121];
  }
  return t38;
};
export const getServerSideProps = getBaseServerSideProps(ContactsLoco, 'header.top_menu.contacts');
export default Contacts;